import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const ExceedCreditLimit = ({
  everIncreased,
  onSelectAnswer,
  backClick,
  setExceedCredit,
  clsName,
  removeFromPending,
}) => {
  const optionHandle = async (e) => {
    // GtmDataLayer({
    //     question: "exceed overdraft",
    // });

    if (e.target.value === "251") {
      setExceedCredit("251");
      onSelectAnswer(e);
    } else if (e.target.value === "252") {
      setExceedCredit("252");
      onSelectAnswer(e);
      removeFromPending("oftenExceedCredit");
      removeFromPending("overLimit");
    }
  };
  let toggle = "";
  if (everIncreased == "248") {
    toggle = "everincresedCredLimit";
  } else {
    toggle = "highestcreditLimit";
  }
  return (
    <div className={`qsSlider slidea8 ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        Did you ever exceed your overdraft limit?
      </h2>
      <ul className="btn-option optinal-items  two-options  slide-up-now  ">
        <li>
          <div className=" option_but ">
            <RadioButtonQuest
              key="exov1"
              className="radio"
              labelName="Yes"
              labelClassName="align-items-center justify-content-center next6"
              onClick={optionHandle}
              value="251"
              name="exceedCredLimit"
              id="exov1"
              dataQuestId={95}
              dataAnsId={251}
              dataAnsLabel="Yes"
            />
          </div>
        </li>
        <li>
          <div className="option_but btn-next">
            <RadioButtonQuest
              key="exov2"
              className="radio"
              labelName="No"
              labelClassName="align-items-center justify-content-center next6"
              onClick={optionHandle}
              value="252"
              name="exceedCredLimit"
              id="exov2"
              dataQuestId={95}
              dataAnsId={252}
              dataAnsLabel="No"
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default ExceedCreditLimit;
